import axios from 'axios';
import { attachFirebaseToken, createAuthRefreshInterceptor } from './authInterceptor';

const apiClient = axios.create({
  headers: { 'Content-Type': 'application/json' },
});

apiClient.interceptors.request.use(attachFirebaseToken);
// On 401/403, force-refresh the Firebase token (picks up changed custom
// claims) and retry the request once. See authInterceptor.js for why.
apiClient.interceptors.response.use(undefined, createAuthRefreshInterceptor(apiClient));

export default apiClient;
